<template>
  <v-list>
    <v-tabs
      v-if="user.isAdminOrSuperuser"
      v-model="tab"
      class="drawer-tab"
      fixed-tabs
      icons-and-text
    >
      <v-tabs-slider />

      <v-tab href="#tab-1" @click="onTabClick(false)">
        Kliendid
        <v-icon>mdi-account-multiple</v-icon>
      </v-tab>

      <v-tab href="#tab-2" @click="onTabClick(true)">
        Töötajad
        <v-icon>mdi-briefcase</v-icon>
      </v-tab>
    </v-tabs>
    <div class="admin-list-link-container">
      <a :href="linkToAdminListView">
        <template v-if="showEmployees">
          Vaata töötajate nimekirja
        </template>
        <template v-else>
          Vaata klientide nimekirja
        </template>
      </a>
    </div>
    <div class="search-wrapper">
      <v-text-field
        v-model="search"
        placeholder="Otsi"
        dense
        prepend-icon="mdi-account-search"
      />
    </div>
    <v-list-item-group color="primary">
      <v-list-item
        v-for="element in filteredList"
        :id="`drawer-element-${element.id}`"
        :key="element.id"
        :to="element.url"
      >
        <span :id="element.id" class="element-list-item">
          {{ element.name }}
        </span>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { DJANGO_ADMIN_URLS } from '@/constants'
import AccessibleClient from '@/dataAccess/models/AccessibleClient'
import Employee from '@/dataAccess/models/Employee'
import DrawerItem from '@/components/Drawer/DrawerItem'

export default {
  data() {
    return {
      search: '',
      tab: null,
      user: this.$store.getters.user,
      showEmployees: false // Determines whether clients or employees are shown
    }
  },
  computed: {
    elementID() {
      return this.$route.params.Id
    },
    elements() {
      let elements
      if (this.showEmployees) {
        elements = (this.user.isSuperuser
          ? Employee.all()
          : Employee.query()
              .where('isSuperuser', false)
              .get()
              .filter(employee => employee.isArchived === false)
        ).map(employee => DrawerItem.fromEmployee(employee))
      } else {
        elements = AccessibleClient.notArchivedAndAccessibleToUser().map(
          client => DrawerItem.fromClient(client)
        )
      }
      return elements.sort(DrawerItem.compare)
    },
    linkToAdminListView() {
      if (this.showEmployees) {
        return DJANGO_ADMIN_URLS.employeeList
      } else {
        return DJANGO_ADMIN_URLS.clientList
      }
    },
    filteredList() {
      return this.elements.filter(element => {
        return element.name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    route() {
      if (this.elementID) {
        // elementID is present in client and employee view, missing in other cases
        autoScrollToSelectedElement(this.elementID)
      } else {
        noSelectedElement()
      }
    },
    showEmployees() {
      this.search = ''
    }
  },
  mounted() {
    autoScrollToSelectedElement(this.elementID)
  },
  methods: {
    onTabClick: function onTabClick(showEmployees) {
      this.showEmployees = showEmployees
    }
  }
}

function autoScrollToSelectedElement(elementId) {
  const selectedElement = document.getElementById(elementId)
  removeHighlightFromPreviousElement()
  if (!selectedElement) {
    return
  }
  selectedElement.classList.add('selected-element')
  const nDrawer = getDrawer()
  nDrawer.scrollTop =
    selectedElement.offsetTop -
    (nDrawer.clientHeight / 2 - selectedElement.clientHeight / 2)
}

function noSelectedElement() {
  removeHighlightFromPreviousElement()
  const nDrawer = getDrawer()
  nDrawer.scrollTop = 0
}

function removeHighlightFromPreviousElement() {
  const previousTerm = document.getElementsByClassName('selected-element')[0] // perhaps 'selected-element' should be an id, not class
  if (previousTerm) {
    previousTerm.classList.remove('selected-element')
  }
}

function getDrawer() {
  return document.getElementById('left-drawer')
}
</script>

<style scoped>
.element-list-item {
  color: #cd5a07;
  text-decoration: none;
  display: inline-block;
  width: 100%;
  height: 100%;
}

.v-list-item:nth-child(odd) {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.admin-list-link-container {
  text-align: center;
  padding: 5px 0;
  background: #fff;
  border-top: solid 1px #eeeeee;
}

.search-wrapper {
  background: #ffffff;
  padding: 5px 15px 0;
  margin-top: -10px;
}
</style>

<style>
.selected-element div a span {
  color: navy !important;
  font-weight: 900;
}

.drawer-tab {
  margin-top: -10px;
}
</style>
